import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-56a87d97")
const _hoisted_1 = { class: "select-box" }
const _hoisted_2 = ["value"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:selectedVal', $event.target.value))),
      style: _normalizeStyle(_ctx.styles),
      tabindex: "0"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createElementBlock("option", {
          value: option.val,
          key: option.label + index
        }, _toDisplayString(option.label), 9, _hoisted_2))
      }), 128))
    ], 36)
  ]))
}